import { jsx as t } from "react/jsx-runtime";
import { lazy as r, Suspense as l } from "react";
const i = r(
  () => import("./GAMMA_BE-jLn0lbFn.js").then((a) => ({
    default: a.Card
  }))
), o = r(
  () => import("./GAMMA_NL-CZUNQWXT.js").then((a) => ({
    default: a.Card
  }))
), u = r(
  () => import("./KARWEI-BS9h2fL7.js").then((a) => ({
    default: a.Card
  }))
);
function m({
  cardNumber: a,
  language: e,
  formulaId: n
}) {
  if (!a) return null;
  switch (n) {
    case "gamma_be":
      return /* @__PURE__ */ t(i, { cardNumber: a, language: e });
    case "gamma_nl":
      return /* @__PURE__ */ t(o, { cardNumber: a });
    case "karwei_nl":
      return /* @__PURE__ */ t(
        u,
        {
          cardNumber: a,
          title: "Digitale Club Karwei-kaart"
        }
      );
    default:
      return null;
  }
}
function s(a) {
  return /* @__PURE__ */ t(l, { fallback: null, children: /* @__PURE__ */ t(m, { ...a }) });
}
export {
  s as LoyaltyCard
};
